<template>
  <div class="main">
    <date></date>
    <backBtn></backBtn>
    <div class="headerTop"></div>

    <div class="activeTitle" style="margin-top: 60px">安全管理</div>
    <div class="activeContent">
      <div class="tabs-box">
        <!-- 活动公告表格 -->
        <div class="systemTitle" style="margin-top: 10px">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;应急演练
        </div>

        <table>
          <colgroup>
            <col width="60%" />
            <col width="40%" />
          </colgroup>
          <tr @click="aqbgInfo(item, '当前位置-首页-应急演练详情')" v-for="(item, index) in dataList1" :key="index">
            <td style="text-align: left">{{ item.bt }}</td>
            <td style="text-align: right">
              {{ item.fbsj && item.fbsj.slice(0, 10) }}
            </td>
          </tr>
          <tr v-if="!dataList1.length" align="center">
            <td colspan="2">暂无数据</td>
          </tr>
        </table>
        <div class="yema1">
          <Pagination style="margin-top: 10px" v-show="query1.total > 0" :total="query1.total"
            :limit.sync="query1.pageSize" :page.sync="query1.pageNum" round="false" :currentPageSize="query1.pageSize"
            layout="total, sizes, prev, pager, next, jumper" @pagination="initPage1" />
        </div>
      </div>
      <div class="ppt">
        <div v-if="imgList.length > 0">
          <el-carousel>
            <el-carousel-item v-for="(row, index) in imgList" :key="index">
              <img style="height: 360px" @click="aqbgInfo(row, '当前位置-首页-应急演练详情')" :src="row.fileUrl" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>

    <div class="construct">
      <div class="system">
        <div class="systemTitle">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;应急预案
        </div>
        <div class="system1" style="margin-top: 20px">
          <table style="width: 100%">
            <colgroup>
              <col width="60%" />
              <col width="40%" />
            </colgroup>
            <tr @click="aqbgInfo(item, '当前位置-首页-应急预案详情')" v-for="(item, index) in dataList2" :key="index">
              <td style="text-align: left">{{ item.bt }}</td>
              <td style="text-align: right">
                {{ item.fbsj && item.fbsj.slice(0, 10) }}
              </td>
            </tr>
            <tr v-if="!dataList2.length" align="center">
              <td colspan="2">暂无数据</td>
            </tr>
          </table>
          <div style="height: 10px"></div>
          <div class="yema2">
            <Pagination v-show="query2.total > 0" :total="query2.total" :limit.sync="query2.pageSize"
              :page.sync="query2.pageNum" round="false" :currentPageSize="query2.pageSize"
              layout="total, sizes, prev, pager, next, jumper" @pagination="initPage2" />
          </div>
        </div>
      </div>
      <div class="view">
        <div class="systemTitle">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;制度清单
        </div>
        <div class="system1" style="margin-top: 20px">
          <table>
            <colgroup>
              <col width="60%" />
              <col width="40%" />
            </colgroup>
            <tr @click="aqbgInfo(item, '当前位置-首页-制度清单详情')" v-for="(item, index) in dataList3" :key="index">
              <td style="text-align: left">{{ item.bt }}</td>
              <td style="text-align: right">
                {{ item.fbsj && item.fbsj.slice(0, 10) }}
              </td>
            </tr>
            <tr v-if="!dataList3.length" align="center">
              <td colspan="2">暂无数据</td>
            </tr>
          </table>
          <div style="height: 10px"></div>
          <div class="yema2">
            <Pagination v-show="query3.total > 0" :total="query3.total" :limit.sync="query3.pageSize"
              :page.sync="query3.pageNum" round="false" :currentPageSize="query3.pageSize"
              layout="total, sizes, prev, pager, next, jumper" @pagination="initPage3" />
          </div>
        </div>
      </div>
    </div>
    <div class="construct">
      <div class="system">
        <div class="systemTitle">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;巡查巡检
        </div>
        <div class="system1" style="margin-top: 20px">
          <table style="width: 100%">
            <colgroup>
              <col width="60%" />
              <col width="40%" />
            </colgroup>
            <tr @click="aqbgInfo(item, '当前位置-首页-巡查巡检详情')" v-for="(item, index) in dataList4" :key="index">
              <td style="text-align: left">{{ item.bt }}</td>
              <td style="text-align: right">
                {{ item.fbsj && item.fbsj.slice(0, 10) }}
              </td>
            </tr>
            <tr v-if="!dataList4.length" align="center">
              <td colspan="2">暂无数据</td>
            </tr>
          </table>
          <div style="height: 10px"></div>
          <div class="yema2">
            <Pagination v-show="query4.total > 0" :total="query4.total" :limit.sync="query4.pageSize"
              :page.sync="query4.pageNum" round="false" :currentPageSize="query4.pageSize"
              layout="total, sizes, prev, pager, next, jumper" @pagination="initPage4" />
          </div>
        </div>
      </div>
      <div class="view">
        <div class="systemTitle">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;安全报告&处置报告
        </div>
        <div class="system1" style="margin-top: 20px">
          <table>
            <colgroup>
              <col width="60%" />
              <col width="40%" />
            </colgroup>
            <tr @click="aqbgInfo(item, '当前位置-首页-安全/处置报告详情')" v-for="(item, index) in dataList5" :key="index">
              <td style="text-align: left">{{ item.bt }}</td>
              <td style="text-align: right">
                {{ item.fbsj && item.fbsj.slice(0, 10) }}
              </td>
            </tr>
            <tr v-if="!dataList5.length" align="center">
              <td colspan="2">暂无数据</td>
            </tr>
          </table>
          <div style="height: 10px"></div>

          <div class="yema2">
            <Pagination v-show="query5.total > 0" :total="query5.total" :currentPageSize="query5.pageSize"
              :limit.sync="query5.pageSize" :page.sync="query5.pageNum" round="false"
              layout="total, sizes, prev, pager, next, jumper" @pagination="initPage5" />
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialog" width="80%">
      <contain v-if="dialog" :currentData="currentData"></contain>
    </el-dialog>
  </div>
</template>

<script>
import backBtn from "../../components/back/index.vue";
import detail from "@/api/detail.js";
import contain from "../../components/detail/index.vue";

import url1 from "../../assets/images/002qbo1Wly1hfzwuioq24j60u011in3k02.jpg";
import url2 from "../../assets/images/002qbo1Wly1hfzwuioq24j60u011in3k02.jpg";
import api from "@/api/safe";
import date from "../../components/header/index.vue";
import wyqyId from "../../config";

export default {
  name: "",
  components: { backBtn, date, contain },
  data() {
    return {
      query1: {
        total: 0,
        pageNum: 1,
        pageSize: 6,
      },
      currentData: {},
      dialogTitle: "",
      dialog: false,
      query: {
        total: 0,
        pageNum: 1,
        pageSize: 6,
      },
      query2: {
        total: 0,
        pageNum: 1,
        pageSize: 6,
      },
      query3: {
        total: 0,
        pageNum: 1,
        pageSize: 6,
      },
      query4: {
        total: 0,
        pageNum: 1,
        pageSize: 6,
      },
      query5: {
        total: 0,
        pageNum: 1,
        pageSize: 6,
      },
      dataList1: [{ zhwyFileEntityList: [] }],
      dataList2: [],
      dataList3: [],
      dataList4: [],
      dataList5: [],
      // imgList: [
      //   {
      //     url: url1,
      //   },
      //   {
      //     url: url2,
      //   },
      // ],

      imgList: [] //轮播图

    };
  },
  created() { },
  mounted() {
    this.initAqbg();
    this.initYjya();
    this.initDazl();
    this.initRcwh();
    this.initCzbg();
    this.getImgs();
  },
  methods: {
    getImgs() {
      let params = {
        total: 0,
        pageNum: 1,
        pageSize: 10000,
        wyqyId: wyqyId,
      };
      api.xffhylquerylist(params).then((res) => {
        if (res.data.code == 200) {
          let list = [];
          let _res = res.data.data.list || [];
          list = _res.filter(v => {
            return v.sfszlbt == 1
          })
          let _imgList = [];
          list.forEach(v => {
            if (v.zhwyFileEntityList.length > 0) {
              v.fileUrl = v.zhwyFileEntityList[0].fileUrl
              _imgList.push(v)
            }
          })
          this.imgList = _imgList.slice(0,5);
        }
      });
    },

    //应急演练
    initAqbg() {
      let params = {
        ...this.query1,
        wyqyId: wyqyId,
      };
      api.xffhylquerylist(params).then((res) => {
        if (res.data.code == 200) {
          // //生产环境
          // if (process.env.VUE_APP_BASE_API == "/prod-api") {
          //   res.data.data.list[0].zhwyFileEntityList.forEach((item) => {
          //     item.fileUrl = this.findCharIndex(item.fileUrl, "/", 3);
          //   });
          // }
          this.dataList1 = res.data.data.list;
          this.query1.total = res.data.data.total;
        }
      });
    },
    aqbgInfo(item, title) {
      this.dialog = true;
      this.dialogTitle = title;
      let params = {
        id: item.id,
        lx: 1,
      };
      detail.listinfo(params).then((res) => {
        if (res.data.code == 200) {
          this.currentData = res.data.data;
        }
      });
    },
    // 生产环境
    findCharIndex(str, char, num) {
      var index = str.indexOf(char);
      for (var i = 0; i < num - 1; i++) {
        index = str.indexOf(char, index + 1);
      }
      let endurl =
        "http://182.140.144.130:9000" + str.substr(index, str.length);
      return endurl;
    },
    initPage1(val) {
      this.query1.pageNum = val;
      this.initAqbg();
    },
    //应急预案
    initYjya() {
      let params = {
        ...this.query2,
        wyqyId: wyqyId,
      };
      api.yjyaquerylist(params).then((res) => {
        if (res.data.code == 200) {
          this.dataList2 = res.data.data.list;
          this.query2.total = res.data.data.total;
        }
      });
    },
    initPage2(val) {
      this.query2.pageNum = val;
      this.initYjya();
    },
    //制度清单
    initDazl() {
      let params = {
        ...this.query3,
        wyqyId: wyqyId,
      };
      api.dazlquerylist(params).then((res) => {
        if (res.data.code == 200) {
          this.dataList3 = res.data.data.list;
          this.query3.total = res.data.data.total;
        }
      });
    },
    initPage3(val) {
      this.query3.pageNum = val;
      this.initDazl();
    },
    //巡查巡检
    initRcwh() {
      let params = {
        ...this.query4,
        wyqyId: wyqyId,
      };
      api.rcwxquerylist(params).then((res) => {
        if (res.data.code == 200) {
          this.dataList4 = res.data.data.list;
          this.query4.total = res.data.data.total;
        }
      });
    },
    initPage4(val) {
      this.query4.pageNum = val;
      this.initRcwh();
    },
    //安全处置报告
    initCzbg() {
      let params = {
        ...this.query5,
        wyqyId: wyqyId,
      };
      api.bgquerylist(params).then((res) => {
        if (res.data.code == 200) {
          this.dataList5 = res.data.data.list;
          this.query5.total = res.data.data.total;
        }
      });
    },
    initPage5(val) {
      this.query5.pageNum = val;
      this.initCzbg();
    },
  },
};
</script>

<style lang="scss" scoped>
.activeContent {
  position: relative;
  display: flex;
  padding: 20px;
  margin-top: 40px;
  height: 360px;
  background: linear-gradient(154deg,
      rgba(0, 132, 255, 0.66) 0%,
      rgba(62, 126, 246, 0) 100%);
  border-radius: 24px 24px 24px 24px;
  opacity: 1;
  border: 2px solid #70e2ee;

  .tabs-box {
    position: relative;
    width: 55%;

    .tabs {
      height: 44px;
      border: 1px solid #07397c;
      border-radius: 4px;
      padding: 3px;
      display: flex;

      .tabsItem {
        width: 50%;
        cursor: pointer;

        img {
          // left: ;
          width: 24px;
          height: 24px;
          vertical-align: middle;
        }

        .tabsTitle {
          text-align: center;
          font-size: 16px;
          font-family: Source Han Sans, Source Han Sans;
          font-weight: 700;
          color: #83a9da;
          line-height: 40px;
        }
      }

      .active {
        width: 50%;
        border: 1px solid #2e82ff;
        border-radius: 6px;

        img {
          width: 24px;
          height: 24px;
          vertical-align: middle;
        }

        .tabsTitle {
          text-align: center;
          font-size: 16px;
          font-family: Source Han Sans, Source Han Sans;
          font-weight: 700;
          color: #fff;
          line-height: 40px;
        }
      }
    }
  }

  .ppt {
    flex: 1;
    margin-left: 20px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

table {
  table-layout: fixed;
  width: 100%;

  margin: 0;
  border-spacing: 0;
}

table td {
  height: 42px;
  border-bottom: 1px solid #07397c;
  cursor: pointer;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.construct {
  display: flex;
  margin-top: 20px;

  .system {
    position: relative;
    flex: 1;
    margin-right: 20px;
    width: 49%;
    height: 360px;
    padding: 20px;
    background: linear-gradient(154deg,
        rgba(0, 132, 255, 0.66) 0%,
        rgba(62, 126, 246, 0) 100%);
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    border: 2px solid #70e2ee;

    .systemTitle {
      width: 100%;

      font-weight: 700;
      color: #ffffff;
      font-size: 16px;
      background: url("../../assets/images/index_titlesmall_bg@2x.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
    }
  }

  .view {
    position: relative;
    flex: 1;
    height: 360px;
    padding: 20px;
    background: linear-gradient(154deg,
        rgba(0, 132, 255, 0.66) 0%,
        rgba(62, 126, 246, 0) 100%);
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    border: 2px solid #70e2ee;

    .systemTitle {
      width: 100%;
      // height: 27px;
      // line-height: 27px;
      font-weight: 700;
      color: #ffffff;
      font-size: 16px;
      background: url("../../assets/images/index_titlesmall_bg@2x.png") no-repeat;
      // background-size: contain;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
    }
  }
}

.yema1 {
  position: absolute;
  right: 0px;
  bottom: 0px;
}

.yema2 {
  position: absolute;
  right: 10px;
  bottom: 15px;
}

::v-deep .el-carousel__container {
  height: 350px;
}

::v-deep .el-dialog {
  width: 800px;
  min-height: 400px;
  background: url("../../assets/images/dialog_bg2.png") no-repeat;
  background-size: 100% 100%;
  border-radius: 24px;

  color: #fff;
  position: relative;
}

::v-deep .el-dialog__title {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
}

::v-deep .el-dialog__header {
  margin: 20px;
  border-bottom: 1px solid #338bea;
}
</style>
